import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'

export class FlashMessages extends React.Component {
    constructor(props) {
        super(props)

        this._isMounted = true

        this.state = {
            messages: window.payload.flash_messages,
            active: true
        }

        if (window.payload.flash_messages.length > 0) {
            this.timer = setTimeout((_) => {
                if (this._isMounted) {
    	    this.setState({active: false})
                    window.payload.flash_messages = {}
                }
  	  }, 5000)
        }

        _.bindAll(this,
            'clickHandler'
        )
    }	

    componentDidMount() {
        this._isMounted = true
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    clickHandler() {
  	clearTimeout(this.timer)
        if (this._isMounted) {
    	this.setState({active: false})
            window.payload.flash_messages = {}
        }
    }


    render() {
        if (this.state.messages.length > 0 ) {
            let classes = this.state.active ? 'success flash-message' : 'success flash-message fadeout'
    	let fMessages = this.state.messages.map((mssg, index) => {
  								      if (mssg.success) {
  								        return <p key={index}>{mssg.success}</p>
  								      }
  										})
  	    return (
      <div className={classes}>
          { fMessages }
          <span className="btn-close" onClick={() => this.clickHandler()}><i className="icon-close"/></span>
      </div>
  	    )
  	  } else {
            return null
        }
    }
}
